export default "__VITE_ASSET__BMMF4FoA__"